<template>
  <span v-if="config?.public?.version" class="text-[.7rem] leading-3">v{{config.public.version}}</span>
</template>
<script setup lang="ts">
const config = useRuntimeConfig();
</script>
